import { ControlValueAccessor } from '@angular/forms';

export abstract class BaseControlValueAccessor<T = any> implements ControlValueAccessor {
  public disabled = false;
  public value: T;

  public onChange(newVal: T) {
    // Vide pour ne pas avoir d'erreur si appelé avant registerOnChange
  }
  public onTouched(_?: any) {
    // Vide pour ne pas avoir d'erreur si appelé avant registerOnTouched
  }

  public writeValue(obj: T): void {
    this.value = obj;
  }
  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  public setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
